(function () {
  'use strict';
  function init() {
    document.querySelectorAll('[data-zr-search]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      var input = root.querySelector('input[type=search]'), panel = root.querySelector('.zr-search-suggestions');
      var status = root.querySelector('[role=status]'), timer, controller, serial = 0;
      function close() { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); }
      function cancel() { clearTimeout(timer); serial++; if (controller) controller.abort(); close(); }
      function link(url, title) {
        var a = document.createElement('a');
        var parsed = new URL(url, location.origin);
        if (parsed.origin !== location.origin) return null;
        a.href = parsed.href; a.textContent = title;
        return a;
      }
      input.addEventListener('input', function () {
        cancel();
        var q = input.value.trim(), request = serial;
        if (q.length < 2) { status.textContent = ''; return; }
        timer = setTimeout(async function () {
          controller = new AbortController();
          try {
            var params = new URLSearchParams({q:q,'resources[type]':'product','resources[limit]':'5','resources[options][fields]':'title,product_type,variants.title,vendor,tag'});
            var response = await fetch(root.dataset.endpoint + '?' + params, {signal:controller.signal});
            if (!response.ok) throw new Error('Search unavailable');
            var data = await response.json();
            if (request !== serial || !root.contains(document.activeElement)) return;
            var products = data.resources.results.products || [];
            panel.replaceChildren();
            products.forEach(function (product) {
              var a = link(product.url, '');
              if (!a) return;
              if (product.image) {
                var img = document.createElement('img'); img.src = product.image; img.alt = ''; img.loading = 'lazy'; a.appendChild(img);
              }
              var text = document.createElement('span'); text.textContent = product.title;
              if (product.price != null && Number.isFinite(Number(product.price))) {
                var price = document.createElement('small');
                price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:root.dataset.currency}).format(Number(product.price)); text.appendChild(price);
              }
              a.appendChild(text); panel.appendChild(a);
            });
            if (!products.length) { var message = document.createElement('p'); message.textContent = 'No quick matches. Try a different name or view all results.'; panel.appendChild(message); }
            var url = new URL(root.querySelector('form').action); url.search = new URLSearchParams({q:q,type:'product','options[prefix]':'last'});
            var all = link(url.href, 'View all results for “' + q + '”'); if (all) panel.appendChild(all);
            panel.hidden = false; input.setAttribute('aria-expanded','true'); status.textContent = products.length + ' product suggestions. Tab to explore.';
          } catch (error) { if (request === serial) { close(); status.textContent = 'Press Search to see results.'; } }
        }, 250);
      });
      root.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { cancel(); input.focus(); }
        if (e.key === 'ArrowDown' && !panel.hidden) { var next = document.activeElement === input ? panel.querySelector('a') : document.activeElement.nextElementSibling; if (next && next.tagName === 'A') { e.preventDefault(); next.focus(); } }
        if (e.key === 'ArrowUp' && !panel.hidden) { var previous = document.activeElement.previousElementSibling; e.preventDefault(); if (previous && previous.tagName === 'A') previous.focus(); else input.focus(); }
      });
      root.addEventListener('focusout', function () { setTimeout(function () { if (!root.contains(document.activeElement)) cancel(); }, 0); });
      document.addEventListener('click', function (e) { if (!root.contains(e.target)) cancel(); });
      root.querySelector('form').addEventListener('submit', cancel);
    });
  }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
}());
